
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import IMapLocation from '../../shared/general/interfaces/IMapLocation'
import locationPointActive from '../../static/assets/svg/LocationPointActive.svg'
import tailwindConfig from '../../tailwind.config.js'
import generateDataUrl from '../../shared/general/services/SvgService'

interface IMapOptions {
  zoom : number
  center : { lat : number, lng : number }
  zoomControl : boolean
  zoomControlOptions : {
    position : number
  }
  mapTypeControl : boolean
  scaleControl : boolean
  streetViewControl : boolean
  rotateControl : boolean
  fullscreenControl : boolean
  tilt : number
}

@Component({ name: 'GoogleMap' })
export default class GoogleMap extends Vue {
  @Prop({ required: true }) zoomLevel! : number

  @Prop({ required: true }) centerMapLocation! : IMapLocation

  @Prop({ required: true }) googleMapsApiKey! : string

  async mounted () {
    await this.createGoogleMap()
  }

  private async createGoogleMap () : Promise<void> {
    const mapsLoaded = await this.$store.dispatch('GoogleMaps/init', {
      apiKey: this.googleMapsApiKey,
      version: 'weekly',
      libraries: ['places'],
    })
    if (!mapsLoaded) return
    const { google } = this.$store.state.GoogleMaps
    const map = await new google.maps.Map(
        this.$refs.map as HTMLElement,
        this.mapOptions(google),
    )

    if (!map) return

    // move the map a bit to the right so the marker isn't touching the overlay
    this.setMapMarkerPosition(map)

    await new google.maps.Marker({
      position: this.mapOptions(google).center,
      map,
      icon: {
        url: await generateDataUrl(locationPointActive),
        scaledSize: new google.maps.Size(82, 90),
      },
    })
  }

  private mapOptions (googleObj : typeof google) : IMapOptions {
    return {
      zoom: this.zoomLevel,
      center: this.centerMapLocation,
      zoomControl: true,
      zoomControlOptions: {
        position: googleObj.maps.ControlPosition.TOP_RIGHT,
      },
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      tilt: 0,
    }
  }

  private setMapMarkerPosition (map : google.maps.Map) : void {
    google.maps.event.addListenerOnce(map, 'idle', () => {
      if (window.innerWidth < +tailwindConfig.theme.screens.sm.replace('px', '')) {
        map.panBy(0, 0)
      } else {
        map.panBy(-150, 0)
      }
    })
  }
}
